import * as React from 'react';
import './form-dialog-footer.scss';

class FormDialogFooter extends React.Component<{}, {}> {
  render() {
    const { children } = this.props;
    return <footer className="FormDialogFooter">{children}</footer>;
  }
}

export default FormDialogFooter;
